import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CompanyNavPageComponent } from "./company-nav-page/company-nav-page.component";
import { CompanyNavGridControlsComponent } from "./company-nav-grid-controls/company-nav-grid-controls.component";
import { CompanyNavGridComponent } from "./company-nav-grid/company-nav-grid.component";
import { Routes, RouterModule } from "@angular/router";
import { SharedModule } from "../shared/shared.module";
import { MatTableModule } from "@angular/material/table";
import { CdkTableModule } from "@angular/cdk/table";
import { IconsModule } from "@va/core-library/icons";
import { CurrencySelectModule } from "@va/core-library/currency-select";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { ButtonModule } from "@va/core-library/button";
import { MultiSelectDropdownModule } from "@va/core-library/multi-select-dropdown";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

const navRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: CompanyNavPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(navRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class CompanyNavRoutingModule {}

@NgModule({
  declarations: [
    CompanyNavPageComponent,
    CompanyNavGridControlsComponent,
    CompanyNavGridComponent,
  ],
  imports: [
    CommonModule,
    IconsModule,
    CompanyNavRoutingModule,
    SharedModule,
    CurrencySelectModule,
    CdkTableModule,
    MatTableModule,
    NzPopoverModule,
    ButtonModule,
    MultiSelectDropdownModule,
    NzSkeletonModule,
    NzSwitchModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class CompanyNavPageModule {}
